import React from 'react';
import axios from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import SelectContainer from '../form/selectContainer';
import CustomInputComponent from '../form/CustomInputComponent';
import CustomTextareaComponent from '../form/CustomTextareaComponent';
import CustomTagsInputComponent from '../form/CustomTagsInputComponent';

const validationSchema = Yup.object().shape({
	nome_servizio: Yup.string().required('Campo richiesto'),
	nome_ente: Yup.string().required('Campo richiesto'),
	tipologia_servizio: Yup.string().required('Campo richiesto'),
	categorie: Yup.string().required('Campo richiesto'),
	sottocategorie: Yup.string().required('Campo richiesto'),
	link_servizio: Yup.string().required('Campo richiesto'),
	descrizione_breve: Yup.string().required('Campo richiesto'),
	descrizione_estesa: Yup.string().required('Campo richiesto'),
	citta: Yup.array().of(
		Yup.object().shape({
			name: Yup.string(),
			numericCode: Yup.string(),
		})
	),
	note_localita: Yup.string().when('citta', {
		is: (citta) => citta.length === 0,
		then: Yup.string().required('Campo richiesto'),
	}),
});

const FormFornisciServizio = () => {
	const formik = useFormik({
		initialValues: {
			nome_servizio: '',
			nome_ente: '',
			tipologia_servizio: '',
			categorie: '',
			sottocategorie: '',
			link_servizio: '',
			descrizione_breve: '',
			descrizione_estesa: '',
			citta: [],
			note_localita: '',
		},
		validationSchema,
		onSubmit: (data) => {
			const fetchData = async () => {
				const response = await axios.post(
					`${window.location.origin}/wp-json/telepass-v1/fornisci_servizio`,
					data
				);
				if (response.status === 200) {
					window.location.href = `${window.location.origin}/thank-you/`;
				}
			};
			fetchData();
		},
	});
	return (
		<form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
			<div className="field">
				<div className="control">
					<CustomInputComponent
						name="nome_servizio"
						placeholder="Nome servizio"
						className="input has-background-white-bis"
						formik={formik}
						{...formik.getFieldProps('nome_servizio')}
					/>
				</div>
			</div>
			<div className="columns is-flex is-multiline">
				<div className="column is-full-mobile is-half-tablet">
					<CustomInputComponent
						name="nome_ente"
						placeholder="Nome ente"
						className="input has-background-white-bis"
						formik={formik}
						{...formik.getFieldProps('nome_ente')}
					/>
				</div>
				<div className="column is-full-mobile is-half-tablet">
					<CustomInputComponent
						name="tipologia_servizio"
						placeholder="Tipologia servizio"
						className="input has-background-white-bis"
						formik={formik}
						{...formik.getFieldProps('tipologia_servizio')}
					/>
				</div>
			</div>
			<SelectContainer formik={formik} />
			<div className="field">
				<div className="control">
					<CustomInputComponent
						name="link_servizio"
						placeholder="Link al servizio"
						className="input has-background-white-bis"
						formik={formik}
						{...formik.getFieldProps('link_servizio')}
					/>
				</div>
			</div>
			<div className="field">
				<div className="control">
					<CustomTextareaComponent
						name="descrizione_breve"
						placeholder="Descrizione breve"
						className="textarea has-background-white-bis"
						formik={formik}
						{...formik.getFieldProps('descrizione_breve')}
					/>
				</div>
			</div>
			<div className="field">
				<div className="control">
					<CustomTextareaComponent
						name="descrizione_estesa"
						placeholder="Descrizione estesa"
						className="textarea has-background-white-bis"
						formik={formik}
						{...formik.getFieldProps('descrizione_estesa')}
					/>
				</div>
			</div>
			<div className="field">
				<CustomTagsInputComponent
					name="citta"
					placeholder="Città dove il servizio è attivo"
					className="input has-background-white-bis"
					formik={formik}
					{...formik.getFieldProps('citta')}
				/>
			</div>
			<div className="field">
				<div className="control">
					<CustomTextareaComponent
						name="note_localita"
						placeholder="Se il servizio è attivo a livello nazionale, regionale o provinciale, specificalo qui (es. servizio attivo in Lombardia)"
						className="textarea has-background-white-bis"
						formik={formik}
						{...formik.getFieldProps('note_localita')}
					/>
				</div>
			</div>
			<div className="form-group">
				<button
					type="submit"
					className="button is-primary-full is-pulled-right"
				>
					Invia
				</button>
			</div>
		</form>
	);
};

export default FormFornisciServizio;
